export default [
  {
    title: 'timelessdesign',
  },
  {
    name: 'description',
    content: 'Wooden Decks and Decking, Wooden Flooring & Wood Furniture for South Africa. '
    + 'We manufacture, supply, install, maintain and repair wooden decks, balustrades, stairs and '
    + 'flooring in Southern Africa.',
  },
  {
    name: 'keywords',
    content: 'wooden decks, wooden decking, deck, decks, decking, sundecks,loft floor,loft deck,'
    + 'flooring, wood, wooden, timber, patio, balconies, pergola, garden furniture, deks, rosewood,'
    + 'hardwoods, kiaat, champhuta, construction, sanding, sealing, hout dekke',
  },
  {
    property: 'og:locale',
    content: 'en_GB',
  },
  {
    property: 'og:type',
    content: 'website',
  },
  {
    property: 'og:title',
    content: 'timelessdesign',
  },
  {
    property: 'og:description',
    content: 'Wooden Decks and Decking, Wooden Flooring & Wood Furniture for South Africa. '
    + 'We manufacture, supply, install, maintain and repair wooden decks, balustrades, stairs and '
    + 'flooring in Southern Africa.',
  },
  {
    property: 'og:url',
    content: 'https://www.timelessdesign.co.za/',
  },
  {
    property: 'og:site_name',
    content: 'timelessdesign',
  },
  {
    property: 'og:image',
    content: '/img/og_image.png',
  },
  {
    property: 'twitter:image',
    content: '/img/og_image.png',
  },
  {
    property: 'twitter:card',
    content: 'summary_large_image',
  },
  {
    property: 'twitter:image:alt',
    content: 'timelessdesign logo',
  },
  {
    property: 'twitter:title',
    content: 'timelessdesign',
  },
  {
    property: 'twitter:description',
    content: 'Wooden Decks and Decking, Wooden Flooring & Wood Furniture for South Africa. '
    + 'We manufacture, supply, install, maintain and repair wooden decks, balustrades, stairs and '
    + 'flooring in Southern Africa.',
  },
];
